import CarouselComponent from "./cousal";
export const Header = (props) => {
  return (
    <header id="header">
      <CarouselComponent/>
    </header>
  );
};
